<template>
  <div>
    <v-card class="card--shadow">
      <v-card-title class="purple accent-4">
        <div class="subtitle-1 white--text">DOT Patient Form</div>
      </v-card-title>
      <v-card-text class="pt-4">
        <v-row>
          <!-- <v-col lg="4">
            <label>Name</label>
            <v-text-field
              v-model.trim="data.patient.name"
              type="text"
              outlined
              dense
              disabled
            ></v-text-field>
          </v-col> -->
          <v-col lg="4">
            <label>DOB</label>
            <v-text-field
              v-model.trim="data.patient.dob"
              type="text"
              outlined
              dense
              disabled
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>Address</label>
            <v-text-field
              v-model.trim="data.patient.address"
              type="text"
              outlined
              dense
              disabled
            ></v-text-field>
          </v-col>

          <v-col lg="4">
            <label>Sex</label>
            <v-radio-group v-model="data.patient.sex" row disabled>
              <v-radio label="Male" value="1"></v-radio>
              <v-radio label="Female" value="2"></v-radio>
            </v-radio-group>
          </v-col>

          <v-col lg="4">
            <label>TB Code</label>
            <v-text-field
              v-model.trim="data.patient.mdrtb_reg_no"
              type="number"
              outlined
              dense
              disabled
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>TB Year</label>
            <v-text-field
              v-model.trim="data.patient.mdrtb_reg_year"
              type="text"
              outlined
              dense
              disabled
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>Type of TB</label>
            <v-text-field
              :value="getTypeofTB(data.patient.type_of_tb)"
              type="text"
              outlined
              dense
              disabled
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>Treatment Regiment</label>
            <v-text-field
              :value="getRegiment(data.patient.mdrtb_regiments)"
              type="text"
              outlined
              dense
              disabled
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>Treatment Start Date</label>
            <v-text-field
              v-model.trim="data.patient.treatment_startdate"
              type="text"
              outlined
              dense
              disabled
            ></v-text-field>
          </v-col>
          <!-- <v-col lg="3" v-show="data.volunteer">
            <label>Volunteer</label>
            <v-text-field
              v-model.trim="data.volunteer.name"
              type="text"
              outlined
              dense
              disabled
            ></v-text-field>
          </v-col> -->
          <v-col lg="3">
            <label>Use App</label>
            <v-text-field
              v-bind:value="data.dots_app_status == 1 ? 'No' : 'Yes'"
              type="text"
              outlined
              dense
              disabled
            ></v-text-field>
          </v-col>
          <v-col lg="3">
            <label>DOT Start Date</label>
            <v-text-field
              v-model.trim="data.dots_startdate"
              type="text"
              outlined
              dense
              disabled
            ></v-text-field>
          </v-col>
          <v-col lg="3">
            <label>DOT End Date</label>
            <v-text-field
              v-model.trim="data.dots_enddate"
              type="text"
              outlined
              dense
              disabled
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>Phone</label>
            <v-text-field
              v-model.trim="data.phone"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col lg="4">
            <label>Body Weight</label>
            <v-text-field
              v-model.trim="data.body_weight"
              type="number"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="12">
            <label>DOTS Drugs</label>
            <v-select
              :items="dots_drugs"
              v-model="computeDotsDrugs"
              item-text="text"
              item-value="value"
              multiple
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn class="form-btn" @click="emitData">
          <v-icon left>mdi-chevron-right-circle-outline</v-icon>Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { dots_drugs } from "../../services/options";

export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          name: null,
          age: null,
          address: null,
          phone: null,
          sex: null,
          volunteer: null,
          body_weight: null,
          tb_code: null,
          tb_year: null,
          type_of_tb: null,
          treatment_startdate: null,
          dots_startdate: null,
          dots_drugs: null,
          mdrtb_regiment: {
            mdrtb_regiment_id: 1,
            dots_app_status: "",
          },
        };
      },
    },
  },
  methods: {
    emitData() {
      if (this.checkError()) {
        this.$emit("emitData", this.data);
      }
    },
    checkError() {
      var error = ``;

      if (this.data.phone == null || this.data.phone.length == 0)
        error += "Phone is required \n";
      else if (this.data.phone.length > 11 || this.data.phone.length < 9)
        error += "Phone is invalid \n";

      if (this.data.body_weight == null || this.data.body_weight.length == 0)
        error += "Body Weight is required \n";
      else if (this.data.body_weight.length > 2)
        error += "Body Weight should be two digits \n";

      if (error.length > 0) this.$toast.error(error);

      return error.length == 0 ? true : false;
    },
    getTypeofTB(id) {
      var text = "";
      if (this.typeOfTBOpt) {
        this.typeOfTBOpt.map((val) => {
          if (val.id == id) {
            text = val.text;
          }
        });
      }
      return text;
    },
    getRegiment(mdrtbRegiments) {
      if (mdrtbRegiments.length === 0) {
        return "";
      }
      const mdrtbRegimentValue = this.mdrTbRegs.find(
        (val) => val.id === mdrtbRegiments[0].mdrtb_regiment_id
      );

      return mdrtbRegimentValue.text;
    },
  },
  computed: {
    ...mapState("InfoData", ["mdrTbRegs", "typeOfTBOpt"]),
    ...mapState("Volunteer", ["volunteers"]),
    computeDotsDrugs: {
      get() {
        return this.data.dots_drugs;
      },
      set(val) {
        this.data.dots_drugs = val.map((v) => {
          return v;
        });
      },
    },
  },
  created() {
    this.$store.dispatch("Volunteer/getVolunteers");
  },
  data() {
    return {
      menu: null,
      dots_drugs,
    };
  },
};
</script>

<style scoped>
.v-card {
  margin: 20px 0px !important;
}
</style>
